@import '../styles/_vars.css';

.notification {
  background-color: var(--color-bg-dark);
  color: var(--color-text-reverse);
  font-size: 1.2em;
  text-align: center;
  padding: 1rem 1rem 1.7rem;
  word-spacing: 1px;
}

.notification a {
  color: var(--color-text-reverse);
  font-weight: bold;
}
